export default function InfoIcon({ className, color = 'currentColor' }) {
  return (
    <svg className={className} width="17" height="17" viewBox="0 0 17 17" fill="none" style={{ color }}>
      <path
        d="M16.4941 8.49512C16.4941 4.07845 12.9108 0.495117 8.49414 0.495117C4.07747 0.495117 0.494141 4.07845 0.494141 8.49512C0.494141 12.9118 4.07747 16.4951 8.49414 16.4951C12.9108 16.4951 16.4941 12.9118 16.4941 8.49512Z"
        stroke="currentColor"
        strokeWidth="0.990085"
        strokeMiterlimit="10"
      />
      <path
        d="M8.49441 7.58408C8.29627 7.58408 8.10625 7.66542 7.96614 7.8102C7.82603 7.95497 7.74732 8.15133 7.74732 8.35608V12.9881C7.74732 13.1928 7.82603 13.3892 7.96614 13.5339C8.10625 13.6787 8.29627 13.7601 8.49441 13.7601C8.69256 13.7601 8.88258 13.6787 9.02269 13.5339C9.1628 13.3892 9.24151 13.1928 9.24151 12.9881V8.35608C9.24151 8.15133 9.1628 7.95497 9.02269 7.8102C8.88258 7.66542 8.69256 7.58408 8.49441 7.58408ZM8.49441 4.49609C8.30971 4.49609 8.12916 4.55269 7.97559 4.65872C7.82201 4.76476 7.70232 4.91547 7.63163 5.0918C7.56095 5.26813 7.54246 5.46216 7.57849 5.64935C7.61452 5.83654 7.70347 6.00849 7.83407 6.14345C7.96467 6.2784 8.13107 6.37031 8.31223 6.40754C8.49338 6.44478 8.68115 6.42567 8.85179 6.35263C9.02243 6.27959 9.16828 6.15591 9.2709 5.99721C9.37351 5.83852 9.42828 5.65195 9.42828 5.46109C9.42828 5.20516 9.32989 4.95971 9.15476 4.77873C8.97962 4.59776 8.74209 4.49609 8.49441 4.49609Z"
        fill="currentColor"
      />
    </svg>
  );
}

